angular.module('account.settings')
    .component('accountSettingsSharedCalendarComponent', {
        templateUrl: 'app/account/settings/shared-calendar.html',
        controller: function ($cookies, toastr, User, SharedCalendarSettings) {
            this.$onInit = () => {
                this.sharedCalendarSettings = {
                    users: []
                }
                SharedCalendarSettings.get().$promise.then(data => this.sharedCalendarSettings = data)
                User.autocomplete().$promise.then(items => this.users = items)
            }

            this.isSelected = user => this.sharedCalendarSettings.users.map(e => e.id).indexOf(user.id) > -1

            this.toggleUserSelection = user => {
                let idx = this.sharedCalendarSettings.users.map(e => e.id).indexOf(user.id)

                if (idx > -1) {
                    this.sharedCalendarSettings.users.splice(idx, 1)
                } else {
                    this.sharedCalendarSettings.users.push(user)
                }
            }

            this.save = () => {
                SharedCalendarSettings.update(this.sharedCalendarSettings).$promise.then(result => {
                    this.sharedCalendarSettings = result
                    toastr.success("Zapisano zmiany")
                })
            }
        }
    })
